import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileSettings } from '../../../../lib/entity/interface/iProfile';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IAddProfileUseCase {
    execute(
        apiKey: string,
        profileName: string,
        profileSettings: IProfileSettings,
        kidsMode: boolean,
        token: string,
        authSign: string,
        identityToken: string,
        apiToken: { [key: string]: string }
    ): Promise<any>;
}

export class AddProfileUseCase implements IAddProfileUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        profileName: string,
        profileSettings: IProfileSettings,
        kidsMode: boolean,
        token: string,
        authSign: string,
        identityToken: string,
        apiToken: { [key: string]: string }
    ): Promise<any> {
        const profile = await this.profileRepository.addProfile(
            apiKey,
            profileName,
            profileSettings,
            kidsMode,
            token,
            authSign,
            identityToken,
            apiToken
        );
        return profile.data;
    }
}
